var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmailVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9453 1C35.4375 1 39 4.5625 39 10.0547V29.9453C39 35.4375 35.4375 39 29.9453 39H10.0547C4.5625 39 1 35.4375 1 29.9453V10.0547C1 4.5625 4.5625 1 10.0547 1H29.9453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9453 1C35.4375 1 39 4.5625 39 10.0547V29.9453C39 35.4375 35.4375 39 29.9453 39H10.0547C4.5625 39 1 35.4375 1 29.9453V10.0547C1 4.5625 4.5625 1 10.0547 1H29.9453Z",
    stroke: "#A4A4A4",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3497 9.86621H7.64974C6.77529 9.86621 6.06641 10.5751 6.06641 11.4495V28.5495C6.06641 29.424 6.77529 30.1329 7.64974 30.1329H32.3497C33.2242 30.1329 33.9331 29.424 33.9331 28.5495V11.4495C33.9331 10.5751 33.2242 9.86621 32.3497 9.86621Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4946_26207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 9,
    width: 28,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3527 9.86621H7.65267C6.77822 9.86621 6.06934 10.5751 6.06934 11.4495V28.5495C6.06934 29.424 6.77822 30.1329 7.65267 30.1329H32.3527C33.2271 30.1329 33.936 29.424 33.936 28.5495V11.4495C33.936 10.5751 33.2271 9.86621 32.3527 9.86621Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4946_26207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30225 13.9766V30.0934L23.199 20.2434L9.30225 13.9766Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4946_26207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23893 30.1326H7.65538C6.78106 30.1326 6.07227 29.4232 6.07227 28.5508V11.5891C6.07227 10.7155 6.60835 12.0401 7.48169 12.0401L9.23893 13.446V30.1326Z",
    fill: "#D54D40"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7001 10.6672C6.7001 10.6672 6.77784 10.0916 6.66384 10.9355C6.54984 11.7794 6.59215 12.7704 6.59215 12.7704L27.3057 34.0056L37.3499 34.1094C37.3499 34.1094 37.2941 19.3952 37.2669 11.0469C37.2666 10.9672 37.2669 8.8252 37.2669 8.8252C37.2669 8.8252 33.6521 11.5339 29.8887 14.3612C26.4961 16.91 23.0827 19.595 20.3418 19.7833C16.2387 20.0654 7.61365 10.8634 7.61365 10.8634L6.7001 10.6672Z",
    fill: "url(#paint0_linear_4946_26207)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4946_26207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7697 12.7726C30.7697 12.7726 30.8076 13.0333 30.7697 13.0333C30.2039 13.0333 32.1947 11.9249 32.1947 11.9249C33.069 11.9249 33.9363 10.8941 33.9363 11.7666V28.5514C33.9363 29.425 33.2267 30.1333 32.3533 30.1333H30.7697V12.7726Z",
    fill: "#C33B2C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_4946_26207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9945 10.2715C32.0351 9.66366 33.1032 9.71892 33.6615 10.553L33.7606 10.7173C34.1419 11.5028 33.9456 12.4262 33.153 12.9996L20.0112 22.508L6.82434 12.9801C6.03495 12.4098 5.90338 11.3635 6.25168 10.7173L6.31932 10.5931C6.82434 9.76794 7.97064 9.65166 8.7562 10.1885L20.0014 18.1551L30.9945 10.2715Z",
    fill: "#DD4D40"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67782 11.6914C6.89518 11.8698 7.16517 12.0404 7.47861 12.0404L9.23585 13.4463V15.488L6.55859 12.7445C6.55859 12.7445 6.60885 12.2665 6.67782 11.6914Z",
    fill: "#AF4A40"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4946_26207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9945 10.2715C32.0351 9.66366 33.1032 9.71892 33.6615 10.553L33.7606 10.7173C34.1419 11.5028 33.9456 12.4262 33.153 12.9996L20.0112 22.508L6.82434 12.9801C6.03495 12.4098 5.90338 11.3635 6.25168 10.7173L6.31932 10.5931C6.82434 9.76794 7.97064 9.65166 8.7562 10.1885L20.0014 18.1551L30.9945 10.2715Z",
    fill: "#DD4D40"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4946_26207",
    x: 6.07227,
    y: 10.291,
    width: 3.1665,
    height: 19.8418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764706 0 0 0 0 0.270588 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4946_26207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4946_26207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4946_26207",
    x: 30.6685,
    y: 10.416,
    width: 3.26807,
    height: 19.7168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.219608 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4946_26207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4946_26207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_4946_26207",
    x: 3.06982,
    y: 7.86133,
    width: 35.8789,
    height: 20.6465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4946_26207"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.290196 0 0 0 0 0.243137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4946_26207",
    result: "effect2_dropShadow_4946_26207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4946_26207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4946_26207",
    x: 6.06982,
    y: 8.86133,
    width: 27.8789,
    height: 13.6465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.290196 0 0 0 0 0.243137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4946_26207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4946_26207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4946_26207",
    x1: 38.7774,
    y1: 22.2085,
    x2: 23.7792,
    y2: 0.336667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD8D8",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailVector);
export default __webpack_public_path__ + "static/media/gmailVector.1dae0e47f3ed820a18441fd471d731f0.svg";
export { ForwardRef as ReactComponent };